<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name of Type"
              label-for="Name of Type"
            >
              <b-form-input
                id="name"
                v-model="groupCerForm.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">

          <validation-provider
            #default="validationContext"
            name="Certificate"
            rules="required"
          >
            <b-form-group
              label="Certificate"
              label-for="Certificate"
            >
              <v-select
                v-model="showNameCertificate"
                class="w-100"
                :options="certificateOptions"
                placeholder="Select By Certificate"
                label="text"
                :searchable="true"
                :clearable="true"
                @input="searchCertificateTable"
                @clear="clearCertificateSelection"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

        </b-col>

        <b-col md="6">
          <validation-provider
            v-if="!loadingCertificate"
            #default="validationContext"
            name="Sub Certificate"
            rules="required"
          >
            <b-form-group
              label="Sub Certificate"
              label-for="Sub Certificate"
            >
              <v-select
                v-model="groupCerForm.certificate_ids"
                class="w-100"
                :options="subCertificateOptions"
                placeholder="Select By Sub Certificate"
                label="text"
                :searchable="true"
                multiple
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-spinner
            v-else
            variant="primary"
            label="Spinning"
          />
        </b-col>
        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addGroupCertificate()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addGroupCertificate()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      showNameCertificate: null,
      certificateOptions: [],
      getSubCertificate: [],
      subCertificateOptions: [],
      loadingCertificate: false,
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const groupCerForm = ref({
    })
    return {
      getValidationState,
      groupCerForm,
    }
  },
  mounted() {
    this.showGroupCertificate()
    this.showCertificate()
  },
  methods: {
    async searchCertificateTable(selectedOption) {
      if (!selectedOption) {
        this.$emit('getIdCertificate', null)
        this.showNameCertificate = null
      } else {
        this.loadingCertificate = true
        this.showNameCertificate = selectedOption.text

        try {
          const response = await axios.get(
            `certificate/${selectedOption.value}`,
          )
          const data = decryptData(response.data.payload)?.data?.certificates
          this.subCertificateOptions = data.map(item => ({
            value: item.id,
            text: `${item.name?.ar} - ${item.name?.en}`,
          }))
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error}`,
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.loadingCertificate = false
        }
      }
      // await this.getAllData()
    },
    async clearCertificateSelection() {
      this.$emit('getIdCertificate', null)
      this.showNameCertificate = null
      try {
        const response = await axios.get('certificate/get-sub')
        const data = decryptData(response.data.payload)?.data?.groups

        this.getSubCertificate = data.map(item => ({
          value: item.id,
          text: `${item.name?.ar} - ${item.name?.en}`,
        }))
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      }
      // await this.getAllData()
    },
    showCertificate() {
      axios.get('certificate_group?all=true')
        .then(res => {
          const dataCertificate = decryptData(res.data.payload)?.data
            ?.certificates
          this.certificateOptions = dataCertificate.map(item => ({
            value: item.id,
            text: `${item.name?.ar} - ${item.name?.en}`,
          }))
        })
    },
    showGroupCertificate() {
      if (this.$route.params.id) {
        axios.get(`certificate-types/${this.$route.params.id}`).then(res => {
          this.groupCerForm = decryptData(res.data.payload).data
          this.groupCerForm.certificate_ids = decryptData(res.data.payload).data.certificates.map(item => ({
            value: item.id,
            text: `${item.name?.ar} - ${item.name?.en}`,
          }))
        })
      } else {
        return false
      }
      return true
    },

    addGroupCertificate() {
      if (this.$route.params.id) {
        this.loader = true

        const formData = new FormData()
        formData.append('_method', 'PUT')

        const excludedKeys = ['id', 'created_at', 'updated_at', 'certificates', 'schema_owner']

        // Use Object.entries() to iterate over the object's own properties
        Object.entries(this.groupCerForm).forEach(([key, value]) => {
          if (excludedKeys.includes(key)) return
          if (key === 'certificate_ids') {
            value.map((item, index) => formData.append(`certificate_ids[${index}]`, item.value))
          } else {
            formData.append(key, value)
          }
        })

        axios
          .post(`certificate-types/${this.$route.params.id}`, formData)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'type-certificate' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${error.response.data.message}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      } else {
        this.loader = true
        const formData = new FormData()

        // Use Object.entries() to iterate over the object's own properties
        Object.entries(this.groupCerForm).forEach(([key, value]) => {
          if (key === 'certificate_ids') {
            value.map((item, index) => formData.append(`certificate_ids[${index}]`, item.value))
          } else {
            formData.append(key, value)
          }
        })

        axios
          .post('certificate-types', formData)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$router.push({ name: 'type-certificate' })
              this.$toasted.show('Created Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${error.response.data.message}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
